import type { Entity } from '../store/types/account';

/** Resolve account capabilities, not the NFC configuration of a pass/template. */
export const resolveNfcCapabilities = (entity?: Partial<Entity> | null) => {
  const appleNfcAvailable =
    entity?.appleNfcEnabled ?? entity?.nfcEnabled ?? false;
  const googleNfcAvailable =
    (entity?.googleNfcEnabled ?? false) || appleNfcAvailable;

  return {
    // Callers must wait for entity resolution before clearing saved settings.
    isResolved: entity != null,
    appleNfcAvailable,
    googleNfcAvailable,
    nfcAvailable: appleNfcAvailable || googleNfcAvailable,
    googleOnly: googleNfcAvailable && !appleNfcAvailable,
  };
};
